import PropTypes from "prop-types";
import React, { useReducer } from "react";

import API from "../../API";
import {
  POPULATE_VEHICLES,
  POPULATE_VEHICLE_COUNT,
  POPULATE_VEHICLE_SEARCH_PARAMS,
} from "../types";
import { StringUtils } from "../../util";

import VehicleContext from "./vehicleContext";
import vehicleReducer from "./vehicleReducer";

const VehicleState = ({ children }) => {
  const initialSearchParams = {
    search: null,
  };
  const initialState = {
    vehicles: [],
    vehicleCount: 50,
    vehicleSearchParams: initialSearchParams,
  };

  const [state, dispatch] = useReducer(vehicleReducer, initialState);

  const setVehicleSearchParams = (params = initialSearchParams) => {
    dispatch({
      type: POPULATE_VEHICLE_SEARCH_PARAMS,
      payload: params,
    });
  };

  const searchVehicles = async (searchParams, ordering = null, pageSize = 50, page = 1) => {
    const parsedParams = {
      ...searchParams,
    };
    if (!parsedParams.search) {
      dispatch({
        type: POPULATE_VEHICLES,
        payload: [],
      });
      dispatch({
        type: POPULATE_VEHICLE_COUNT,
        payload: 0,
      });
      return;
    }
    try {
      const data = await API.vehicle.list({
        ...parsedParams,
        ordering,
        page_size: pageSize,
        page,
      });
      const results = data.results.map((vehicle) =>
        vehicle.url ? { ...vehicle, id: StringUtils.uuidFromUrl(vehicle.url) } : vehicle,
      );
      dispatch({
        type: POPULATE_VEHICLES,
        payload: results,
      });
      dispatch({
        type: POPULATE_VEHICLE_COUNT,
        payload: data.count,
      });
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <VehicleContext.Provider
      value={{
        vehicles: state.vehicles,
        vehicleCount: state.vehicleCount,
        vehicleSearchParams: state.vehicleSearchParams,
        initialSearchParams,
        setVehicleSearchParams,
        searchVehicles,
      }}
    >
      {children}
    </VehicleContext.Provider>
  );
};

VehicleState.propTypes = {
  children: PropTypes.node.isRequired,
};

export default VehicleState;
